import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'

export interface SendSmsPayload {
  to: string
  body: string
  leadId?: string
}

export interface TelephonyVendorInfo {
  vendor: 'aircall' | 'dialpad'
  email: string
  smsFromNumber: string | null
  smsEnabled: boolean
  isDefault: boolean
}

export interface TelephonyMe {
  defaultVendor: 'aircall' | 'dialpad' | null
  vendors: TelephonyVendorInfo[]
}

function sendSms(payload: SendSmsPayload) {
  return axios
    .post('/api/v1/insure/telephony/sms/send/', {
      to: payload.to,
      body: payload.body,
      lead_id: payload.leadId,
    })
    .then((r) => toCamelCase(r.data))
}

export function useSendSms(leadId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: sendSms,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [CacheKeys.SALES_LEADS, leadId] })
      qc.invalidateQueries({ queryKey: [CacheKeys.TELEPHONY_SMS] })
    },
  })
}

export function useTelephonyMe() {
  return useQuery({
    queryKey: ['telephony-me'],
    queryFn: () => axios.get('/api/v1/insure/telephony/me/').then((r) => toCamelCase(r.data) as TelephonyMe),
  })
}

export function useSetDefaultVendor() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vendor: 'aircall' | 'dialpad') =>
      axios.post('/api/v1/insure/telephony/default-vendor/', { vendor }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['telephony-me'] }),
  })
}
